import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationResult } from '@classifieds-sell/datalayer';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { MotorsSectionBase } from '../../motors-section-base';
import { StepIds } from '../../../models/motors-step/motors-step-model';
import { getMotorsTitleByStepIdAndCategory } from '../../../models/draft/draft.constants';

@Component({
    selector: 'motors-summary-page-validation-summary-section',
    templateUrl: './summary-page-validation-summary-section.component.html',
    styleUrls: ['./summary-page-validation-summary-section.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SummaryPageValidationSummarySectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    firstInvalidStepId: StepIds;
    firstInvalidStepTitle: string;
    invalidStepsMessage: string;

    constructor(
        draftFacade: MotorsDraftFacade,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit();

        this.draftFacade.validationResults$
            .pipe(takeUntil(this._destroyed$))
            .subscribe((validationResults) => {
                const filteredValidationResults =
                    validationResults?.filter(
                        (v) => v.stepId !== StepIds.summary
                    ) || [];
                this.setValidationInfo(filteredValidationResults);
                this._changeDetectorRef.markForCheck();
            });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }

    setValidationInfo(validationResults: ValidationResult[]) {
        const invalidStepResults = validationResults?.filter(
            (v) => v.isValid !== true
        );

        if (invalidStepResults && invalidStepResults.length > 0) {
            this.firstInvalidStepId = invalidStepResults[0].stepId as StepIds;

            const invalidStepTitles = invalidStepResults.map((r) =>
                getMotorsTitleByStepIdAndCategory(
                    r.stepId as StepIds,
                    this.categoryId
                )
            );

            this.firstInvalidStepTitle = invalidStepTitles[0];

            // Setup the comma separated error message
            this.invalidStepsMessage = invalidStepTitles.reduce(
                (previous, current, index, array) => {
                    if (index === array.length - 1) {
                        return previous + ' and ' + current;
                    } else {
                        return previous + ', ' + current;
                    }
                }
            );
        }
    }

    goToSection() {
        this.router.navigate([`../${this.firstInvalidStepId}`], {
            relativeTo: this.activatedRoute,
            queryParams: this.activatedRoute.snapshot.queryParams
        });
    }
}
